import Vue from "vue";

const messageFrom = (error) =>
  error?.response?.data?.error?.message || error?.response?.data?.message || error?.message || "No se pudo completar la operación.";

const request = async ({ commit }, config, success) => {
  commit("SET_LOADING", true);
  commit("SET_ERROR", null);
  try {
    const { data } = await Vue.axios(config);
    if (success) success(data, commit);
    return { status: true, data };
  } catch (error) {
    const message = messageFrom(error);
    commit("SET_ERROR", message);
    return { status: false, message };
  } finally {
    commit("SET_LOADING", false);
  }
};

export const getMyWallet = (context) => request(context, {
  method: "GET",
  url: "/asocoins/me",
}, (data, commit) => commit("SET_WALLET", data.wallet));

export const getMyMovements = (context, params = {}) => request(context, {
  method: "GET",
  url: "/asocoins/me/movements",
  params,
}, (data, commit) => commit("SET_MOVEMENTS", data));

export const getSurveys = (context, params = {}) => request(context, {
  method: "GET",
  url: "/asocoins/surveys",
  params,
}, (data, commit) => commit("SET_SURVEYS", data.surveys));

export const getAdminSurveyResponses = (context, { surveyId, params = {} }) => request(context, {
  method: "GET",
  url: `/asocoins/admin/surveys/${surveyId}/responses`,
  params,
});

export const getAdminSurveys = (context) => request(context, {
  method: "GET",
  url: "/asocoins/admin/surveys",
}, (data, commit) => commit("SET_ADMIN_SURVEYS", data.surveys));

export const createSurvey = (context, payload) => request(context, {
  method: "POST",
  url: "/asocoins/admin/surveys",
  data: payload,
});

export const respondSurvey = (context, { surveyId, answers }) => request(context, {
  method: "POST",
  url: `/asocoins/surveys/${surveyId}/respond`,
  data: { answers },
});

export const getOrderEligibility = (context, orderId) => request(context, {
  method: "GET",
  url: `/asocoins/orders/${orderId}/eligibility`,
}, (data, commit) => commit("SET_ELIGIBILITY", data));

export const confirmOrder = (context, orderId) => request(context, {
  method: "POST",
  url: `/asocoins/orders/${orderId}/confirm`,
});

export const getAdminSofomes = (context, params = {}) => request(context, {
  method: "GET",
  url: "/asocoins/admin/sofomes",
  params,
}, (data, commit) => commit("SET_SOFOMES", data));

export const getAdminRules = (context, params = {}) => request(context, {
  method: "GET",
  url: "/asocoins/admin/rules",
  params,
}, (data, commit) => commit("SET_RULES", data.rules));

export const getAdminWallet = (context, sofomId) => request(context, {
  method: "GET",
  url: `/asocoins/admin/accounts/${sofomId}`,
}, (data, commit) => commit("SET_ADMIN_WALLET", data.wallet));

export const getAdminMovements = (context, { sofomId, params = {} }) => request(context, {
  method: "GET",
  url: `/asocoins/admin/accounts/${sofomId}/movements`,
  params,
}, (data, commit) => commit("SET_ADMIN_MOVEMENTS", data));

export const assignAsocoins = (context, { sofomId, payload }) => request(context, {
  method: "POST",
  url: `/asocoins/admin/accounts/${sofomId}/assign`,
  data: payload,
});

export const adjustAsocoins = (context, { sofomId, payload }) => request(context, {
  method: "POST",
  url: `/asocoins/admin/accounts/${sofomId}/adjust`,
  data: payload,
});

export const updateRule = (context, { ruleId, payload }) => request(context, {
  method: "PATCH",
  url: `/asocoins/admin/rules/${ruleId}`,
  data: payload,
});

export const configureEntity = (context, { type, id, payload }) => request(context, {
  method: "POST",
  url: `/asocoins/admin/${type}/${id}/config`,
  data: payload,
});

export const configureSurvey = (context, { publicationId, payload }) => request(context, {
  method: "POST",
  url: `/asocoins/admin/surveys/${publicationId}/config`,
  data: payload,
});

export const runExpirations = (context) => request(context, {
  method: "POST",
  url: "/asocoins/admin/expire",
});
